import { UserApi } from '@/api/userApi';
import router from '@/router';
import store from '@/store';

const state = {
    username: '',
    email: '',
    full_name: '',
    access_token: '',
    expires_in: null,
    ward_id: null,
    stake_id: null,
    logged_in: false,
    roles: [],
    restrict_to_orgs: [],
    ward_roles: [],
};

const getters = {
    username: state => state.username,
    email: state => state.email,
    full_name: state => state.full_name,
    ward_id: state => state.ward_id,
    stake_id: state => state.stake_id,
    expires_in: state => state.expires_in,
    restrict_to_orgs: state => state.restrict_to_orgs,
    available_ward_roles: state => state.ward_roles,
    isTokenExpired: (state) => {
        // safe guard
        if (!state.access_token) return true;
        const expiredDate = parseFloat(state.expires_in);
        let currentDate = Date.now() / 1000;
        let isExpired = expiredDate < currentDate;
        //console.log(`token: ${state.access_token} ExpiresIn: ${state.expires_in} ExpiredDate: ${expiredDate} CurrentDate: ${currentDate} Expired: ${isExpired}`);
        if(isExpired) {
            console.log('Bailing Out! Expired!!')
            return true;
        }
        return false;
    }
};

const mutations = {
    saveUser(state, payload) {
        state.email = payload.email;
        state.full_name = payload.full_name;
        state.ward_id = payload.ward_id;
        state.stake_id = payload.stake_id;
        state.roles = payload.application_roles;
        state.username = payload.username;
        state.logged_in = true;
        state.restrict_to_orgs = payload.restrict_to_orgs;
        state.ward_roles = payload.application_roles; // a user can only give access to these roles
    },
    userLoginChanged(state, payload) {
        state.access_token = payload.access_token;
        state.expires_in = payload.expires_in;
        state.logged_in = true;
    },
    clearUser(state) {
        state.email = null;
        state.username = null;
        state.email = null;
        state.access_token = null;
        state.full_name = null;
        state.ward_id = null;
        state.stake_id = null;
        state.logged_in = false;
        state.roles = [];
        state.expires_in = null;
        state.restrict_to_orgs = [];
        state.ward_roles = [];
    }

};

const actions = {
    async loadUser({ commit, state }, takeToWard=true) {
        const { data } = await UserApi.getUser();
        commit('saveUser', data);
        store.dispatch('frontEndSettings/loadRoles');
        if (data.change_pass_on_login) {
            router.push({ name: 'user-credentials'});
            return;
        }
        // do not route to default ward/stake take to whatever the route dictates.
        if (!takeToWard) {
          return;
        }
        if(state.ward_id !== null && state.ward_id !== '' && state.ward_id !== undefined){
            router.push({ name: 'ward-list', params: {'wardId': state.ward_id}});
            return;
        }
        if(state.stake_id !== null && state.stake_id !== '' && state.stake_id !== undefined){
            router.push({ name: 'stake-detail', params: {'stakeId': state.stake_id}});
            return;
        }
        //send the user to it's profile if no stake or ward list is set.
        router.push({ name: 'user'})
    }
};

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
};
